<!-- <div class="product-count" *ngIf="(option?.product?.encourage_order && product?.encourage_order) ||
    (option?.product?.encourage_view && product?.encourage_view)">
    <ul>
        <li *ngIf="option?.product?.encourage_order && product?.encourage_order">
            <i class="ri-flashlight-line"></i>
            <h6 class="lang">{{ ordersCount }} {{ 'customers_ordered' | translate }}</h6>
        </li>
        <li *ngIf="option?.product?.encourage_view && product?.encourage_view">
            <i class="ri-eye-line"></i>
            <h6 class="lang">{{ viewsCount }} {{ 'active_view_in_this_item' | translate }}</h6>
        </li>
    </ul>
</div> -->
<div class="d-flex flex-column gap-3">
  <div class="d-flex flex-column gap-1">
    <div class="d-flex align-items-center gap-3">
      <h1 class="name mb-0">{{ product.name }}</h1>
      <!-- <div
        *ngIf="product.coinIconLevel > 0"
        class="coin-markup"
        [class]="'coin-' + product.cartItem.coinIconLevel"
        [id]="'coin-markup-' + product.productID"
      >
        <img
          [src]="'assets/svg/gift/coin_' + product.coinIconLevel + '.svg'"
          style="width: 20px; height: 20px"
         loading="lazy" />
      </div> -->
    </div>
    <div *ngIf="product.packagingSpecifications" style="font-size: 13px; width: fit-content; color: #6E6E72; font-weight: 500;">
      {{ product.packagingSpecifications }}
    </div>
  </div>

  <ng-container *ngIf="!isAuthenticated">
    <div class="text-center">
      <app-button
        class="btn rounded-pill p-1 d-flex align-items-center justify-content-center"
        style="
          background-color: var(--theme-color);
          color: white;
          border: none;
          max-width: 400px;
          text-align: center;
        "
        type="button"
        [spinner]="false"
        id="btn_login"
        (click)="LoginModal.openModal()" data-cta="product.login_to_see_price" data-cta-loc="product"
      >
        Đăng nhập để xem giá
      </app-button>
    </div>
  </ng-container>
  <div
    class="price-rating"
    *ngIf="product.stockStatus != 8 && product.basePrice > 0"
  >
    <ng-container *ngIf="!(product | showPreviewPrice)">
      <div style="color: #CF1322; font-size: 24px; font-weight: 600;">
        {{ product.pricingTablePrice | currencySymbol }}
      </div>

      <div class="d-flex align-items-center gap-2">
        <del
          style="font-weight: 400; font-size: 15px; color: #6E6E72;"
          *ngIf="product.pricingTablePrice < product.basePrice"
        >
          {{ product.basePrice | currencySymbol }}
        </del>
        <span
          style="color: #CF1322; font-weight: 400; font-size: 15px;"
          *ngIf="product.pricingTablePrice < product.basePrice"
        >
          -{{
            Math.max(
              0.01,
              (product.basePrice - product.pricingTablePrice) / product.basePrice
            ) | percent: "1.0-0"
          }}
        </span>
      </div>
      <div *ngIf="product.basePrice > 0 && ((product.vat || 0) > 0 || (product.cartItem?.vat || 0) > 0)" style="color: #9C9C9C; font-size: 13px; font-style: italic; margin-top: 4px;">
        *Giá đã bao gồm {{ product.vat || product.cartItem?.vat }}% VAT
      </div>
    </ng-container>

    <ng-container *ngIf="product | showPreviewPrice">
      <app-deal-shock-preview-price class="d-none d-md-block d-lg-block d-xl-block d-xxl-block"
        [product]="product"
        [canShowTooltip]="true"
        [p]="{
          'p1': 'line-height: unset !important;',
          'p2': 'width: 20px !important; height: 20px !important;',
          'p3': 'display: block !important;',
          'p4': 'font-size: 15px !important;',
          'p5': 'font-size: 15px !important;',
        }"
      ></app-deal-shock-preview-price>

      <app-deal-shock-preview-price class="d-sm-block d-md-none d-lg-none d-xl-none d-xxl-none"
        [product]="product"
        [canShowTooltip]="true"
        [p]="{
          'p1': 'line-height: unset !important;',
          'p2': 'width: 20px !important; height: 20px !important;',
          'p3': 'display: block !important;',
          'p4': 'font-size: 13px !important;',
          'p5': 'font-size: 13px !important;'
        }"
      ></app-deal-shock-preview-price>
      <div *ngIf="product.basePrice > 0 && ((product.vat || 0) > 0 || (product.cartItem?.vat || 0) > 0)" style="color: #9C9C9C; font-size: 13px; font-style: italic; margin-top: 4px;">
        *Giá đã bao gồm {{ product.vat || product.cartItem?.vat }}% VAT
      </div>
      <!-- <app-deal-shock-button [product]="product" [type]="'detail'"></app-deal-shock-button> -->
    </ng-container>
  </div>

  <div
    *ngIf="
      product.appliedPricingTable &&
      product.appliedPricingTable.subType == 0 &&
      product.currentSellingPercent != 0 &&
      product.basePrice > 0 &&
      product.stockStatus != 8
    "
    class="progress-bar-width"
  >
    <div class="progress">
      <div
        class="progress-bar"
        role="progressbar"
        [style]="
          'width:' +
          (product.currentTier!.remainingQuantity <= 100
            ? 50
            : product.currentSellingPercent) +
          '%;'
        "
      ></div>
      <div
        class="text-white m-auto mobile"
        style="
          font-size: 12px;
          font-weight: 700;
          line-height: 16px;
          text-transform: uppercase;
          z-index: 1;
        "
      >
        {{ product.progressLabel }}
      </div>
    </div>
  </div>

<ng-container *ngIf="!product.warningStatus || product.warningStatus === ''">
  <div
    class="out-of-stock-label"
    *ngIf="isAuthenticated && product.basePrice <= 0"
  >
    <h3
      *ngIf="product.stockStatus != 8"
      class="out-of-stock-text"
      style="color: #CF1322"
    >
      Sản phẩm tạm thời hết hàng
    </h3>
    <h3
      *ngIf="product.stockStatus == 8"
      class="out-of-stock-text"
      style="color: #CF1322; text-underline-offset: 4px; text-decoration: underline;"
    >
      Xác minh hồ sơ KD để xem giá
    </h3>
  </div>
  <div
    class="out-of-stock-label"
    *ngIf="isAuthenticated && product.basePrice > 0 && product.stockStatus > 8"
  >
    <h3
      *ngIf="product.stockStatus == 9"
      class="out-of-stock-text"
      style="color: #CF1322; text-underline-offset: 4px; text-decoration: underline;"
    >
      Xác minh hồ sơ KD để đặt hàng
    </h3>
    <h3
      *ngIf="product.stockStatus == 10"
      class="out-of-stock-text"
      style="color: #CF1322; text-underline-offset: 4px; text-decoration: underline;"
    >
      Không thuộc phạm vi KD
    </h3>
  </div>
</ng-container>

<ng-container *ngIf="product.warningStatus && product.warningStatus !== ''">
  <div class="out-of-stock-label">
    <a [routerLink]="product.stockStatus !== 0 ? '/account/my-business-profile': null">
      <h3
        class="out-of-stock-text"
        style="color: #CF1322;"
        [style.text-underline-offset.px]="product.stockStatus !== 0 ? 4 : 0" [style.text-decoration]="product.stockStatus !== 0 ? 'underline' : 'none'"
      >
        {{ product.warningStatus }}
      </h3>
    </a>
  </div>
</ng-container>

<div *ngIf="!product.hasProductVoucher && product.pricingTablePrice < product.basePrice">
  <img [src]="'assets/svg/tags/promo.svg'" alt="promo" loading="lazy" />
</div>

<div *ngIf="product.hasProductVoucher">
  <img [src]="'assets/svg/tags/promo-tag-orange.svg'" alt="promo-tag-orange" loading="lazy" />
</div>
<div *ngIf="product.voucherDiscounts && product.voucherDiscounts.length >= 1" class="d-flex flex-column gap-3">
  <div class="d-flex gap-2 justify-content-between p-2"
    (click)="selectVoucher(product.voucherDiscounts[0])" data-cta="product.voucher_select" data-cta-loc="product_detail"
    style="font-size: 16px; color: #FF5D17; background-color: #FFE7DC; border-radius: 8px; cursor: pointer;">
    <div class="d-flex gap-2 align-items-center">
      <img width="24" height="24" src="assets/svg/product/voucher.svg" alt="voucher"  loading="lazy" />
      <span>
        {{ product.voucherDiscounts[0].description || product.voucherDiscounts[0].voucherName }}
      </span>
    </div>
    <i class="ri-arrow-right-s-line" style="font-size: 24px;"></i>
  </div>
  <div class="d-flex gap-3 align-items-center py-2 voucher-container" style="max-width: 100%; overflow-x: auto;">
    <div class="fw-bold" style="min-width: fit-content; font-size: 16px;">Mã ưu đãi có thể dùng</div>
    <div class="d-flex" style="gap: 12px">
      <div class="voucher" *ngFor="let item of product.voucherDiscounts; let i = index" (click)="selectVoucher(item)" data-cta="product.voucher_select" data-cta-loc="product_detail">
        {{ item.voucherCode }}
      </div>
    </div>
  </div>
</div>
<div class="d-none d-md-block">
  <app-banner-policy *ngIf="isBrowser" [banners]="productBanner"></app-banner-policy>
</div>

<app-product-information
 *ngIf="isBrowser"
  [product]="product"
  [cart]="cart"
  [vouchers]="vouchers"
  [productSuggestions]="productSuggestions"
  [productVouchers]="productVouchers"
  [selectedVoucherCode]="selectedVoucherCode"
  [isAuthenticated]="isAuthenticated"
  [productBanner]="productBanner"
  [productPolicy]="productPolicy"
></app-product-information>
<!-- <div class="product-contain" *ngIf="product?.short_description">
    <p [innerHTML]="product.short_description"></p>
</div>
<div class="product-package">
    <app-variant-attributes [product]="product" [attributes]="product.attributes || []"
        (selectVariation)="selectVariation($event!)" [owlCar]="owlCar">
    </app-variant-attributes>
</div>
<app-sale-timer [startDate]="product.sale_starts_at" [endDate]="product.sale_expired_at"
    *ngIf="product.sale_starts_at && product.sale_expired_at">
</app-sale-timer> -->
<!-- <div class="note-box product-package">
  <div class="cart_qty qty-box product-qty">
    <div class="input-group">
      <app-counter *ngIf="cartItem" [cartItem]="cartItem" style="width: 100%;"></app-counter>
    </div>
  </div>
  <div class="wishlist-btn-group">
    <app-button
      [class]="'wishlist-button btn'"
      [id]="'wishlist_btn'"
      [spinner]="false"
      (click)="addToWishlist(product.productID)"
    >
      <i class="ri-heart-line"></i>
    </app-button>
    <app-button
      [class]="'wishlist-button btn'"
      [id]="'compare_btn'"
      [spinner]="false"
      (click)="addToCompare(product.productID)"
    >
      <i class="ri-refresh-line"></i>
    </app-button>
  </div>
</div> -->
<!-- <div class="dynamic-checkout">
  <app-button
    [class]="'btn btn-md bg-theme'"
    [id]="'buynowbtn' + product.productID"
    [disabled]="product.stockStatus != tempporarilyUnavailable ? false : true"
    (click)="buyNow(product)"
  >
    Mua ngay
  </app-button>
  <app-button
    [id]="'addcartbtnVariation' + product.productID"
    [class]="'btn btn-md border-theme-color scroll-button'"
    (click)="addToCart(product)"
    *ngIf="product.stockStatus != tempporarilyUnavailable; else outStock"
  >
    <i class="ri-shopping-cart-line me-1"></i> {{ "add_to_cart" | translate }}
  </app-button>
  <ng-template #outStock>
    <app-button
      [class]="'btn btn-md border-theme-color scroll-button disabled'"
      [id]="'soldoutbtnproductcontain'"
      [spinner]="false"
      [disabled]="true"
    >
      <i
        class="ri-shopping-cart-line me-1"
        *ngIf="product.stockStatus == tempporarilyUnavailable"
      ></i>
      {{
        (product.stockStatus == tempporarilyUnavailable ? "sold_out" : "add_to_cart")
          | translate
      }}
    </app-button>
  </ng-template>
</div> -->

@if (isBrowser) {
  <app-login-modal
    #loginModal
    (openRegistryModal)="openRegistryModal($event)"
    (openForgotPasswordModal)="openForgotPasswordModal($event)"
  ></app-login-modal>
  <app-registry-modal-v2
    #registryModal
    (openLoginModal)="openLoginModal($event)"
  ></app-registry-modal-v2>
  <app-forgot-password-modal
    #forgotPasswordModal
    (openRegistryModal)="openRegistryModal($event)"
  ></app-forgot-password-modal>

  <app-voucher-detail-modal #detailModal [selectedVoucher]="selectedVoucher"
    (closeModalEvent)="closeModalVoucher()"></app-voucher-detail-modal>
}
